"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconTextBold = Experimental__IconTextBold;
exports.IconTextBold = IconTextBold;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconTextBold/index.tsx)
 */
function IconTextBold(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M4.012.9h4c.934 0 1.727.153 2.38.46.654.293 1.14.707 1.46 1.24.32.533.48 1.147.48 1.84 0 .573-.126 1.1-.38 1.58-.24.48-.573.873-1 1.18a3.972 3.972 0 0 1-1.049.51 4.57 4.57 0 0 1-.41.11l.02-.18c.133.019.263.042.39.07.505.11.955.294 1.35.55.493.307.873.713 1.14 1.22.28.493.42 1.047.42 1.66 0 .747-.167 1.42-.5 2.02-.32.6-.82 1.073-1.5 1.42-.667.347-1.507.52-2.52.52h-4.28V.9Zm4.14 12.92c.694 0 1.267-.113 1.72-.34.467-.227.814-.547 1.04-.96.227-.427.34-.92.34-1.48 0-.533-.12-.993-.36-1.38-.24-.4-.586-.707-1.04-.92-.453-.213-1-.32-1.64-.32h-2.68v5.4h2.62Zm-.24-6.66c.654 0 1.194-.113 1.62-.34.44-.227.767-.527.98-.9a2.56 2.56 0 0 0 .32-1.26c0-.52-.113-.96-.34-1.32-.213-.373-.54-.66-.98-.86-.44-.2-.993-.3-1.66-.3h-2.32v4.98h2.38Z\'/><path d=\'M9.492 7.82a4.57 4.57 0 0 0 .411-.11 5.151 5.151 0 0 0-.39-.07l-.02.18Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M7 3.87h4.716c1.104 0 2.032.176 2.783.529.766.353 1.334.836 1.702 1.449.383.613.575 1.319.575 2.116 0 .66-.146 1.265-.437 1.817a3.71 3.71 0 0 1-1.15 1.334 4.714 4.714 0 0 1-1.725.713l.023-.207c.782.107 1.457.345 2.024.713a3.598 3.598 0 0 1 1.334 1.38c.322.567.483 1.211.483 1.932 0 .859-.192 1.633-.575 2.323-.384.69-.966 1.234-1.748 1.633s-1.771.598-2.967.598H7V3.87Zm4.877 14.697c.766 0 1.403-.123 1.909-.368.521-.245.905-.598 1.15-1.058.245-.475.368-1.02.368-1.633 0-.598-.13-1.112-.391-1.541-.26-.43-.644-.759-1.15-.989-.506-.245-1.112-.368-1.817-.368h-2.99v5.957h2.92Zm-.3-7.567c.737 0 1.342-.123 1.818-.368.49-.245.85-.575 1.08-.989.23-.43.346-.905.346-1.426 0-.567-.123-1.05-.368-1.449-.23-.414-.59-.728-1.081-.943-.49-.215-1.104-.322-1.84-.322H8.956V11h2.622Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTextBold is deprecated and will be archived soon. Use IconTextBold instead.
 */
function Experimental__IconTextBold(props) {
  return /*#__PURE__*/_react["default"].createElement(IconTextBold, props);
}